import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en.json";
import sv from "./locales/se.json";
i18n.use(initReactI18next).init({
  // we init with resources
  resources: {
    en,
    sv
  },
  fallbackLng: "sv",
  debug: false,
  // have a common namespace used around the full app
  ns: ["translations"],
  nsSeparator: false, // ✅ Tắt namespace separator
  defaultNS: "translations",
  keySeparator: ".", // we use content as keys

  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ",",
  },

  react: {
    wait: true,
    useSuspense: false
  },
});

export default i18n;
